module.exports = __webpack_public_path__ + "img/ng.c2b19d37.svg";